import * as R from "ramda";
import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects'
import { CompanyData } from "src/app/shared/domains/master/company";
import { MasterService } from "src/app/shared/domains/master/master.service";
import { SharedStateStore } from "src/app/shared/reducers";
import { GetFiltersError, GetFiltersSuccess, PAActionTypes } from "../actions/paFilters";
import { PAFilterService } from "../domains/filter.service";



function* fetch(): any {
  try {
    const {currentUser} = yield select(({shared}: { shared: SharedStateStore }) => shared.user);
    let companiesx: CompanyData[] = yield call(MasterService.fetchCompanyCodeBySystemAlias, null, !R.isEmpty(currentUser.defaultSystemAlias) ? currentUser.defaultSystemAlias[0] : '');
    const mapper = value => ({ id: value.CompCode, title: value.CompCodeDesc });
    const companies = yield companiesx.map(mapper);
    yield put(new GetFiltersSuccess({
      companies,
    }));
  } catch (error) {
    yield put(new GetFiltersError(error));
  }
}

function* watchGetFilters() {
  yield takeLatest(PAActionTypes.PA_GET_FILTERS, fetch);
}

export default function* filterSaga() {
  yield all([
    fork(watchGetFilters),
  ])
};
